// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-dropdown-container {
  position: relative;
  display: flex;
  align-items: center;
  z-index: 2;
}
.simple-dropdown-container ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.simple-dropdown-container .label {
  color: var(--gray);
  font-size: 14px;
  margin-right: 4px;
}
.simple-dropdown-container .selected-value {
  cursor: pointer;
  color: var(--gray_dark2);
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.simple-dropdown-container .selected-value.disabled {
  color: var(--gray_light1);
  cursor: auto;
}
.simple-dropdown-container .selected-value.disabled .drop-icon {
  fill: var(--gray_light1);
}
.simple-dropdown-container .selected-value .drop-icon {
  fill: var(--gray_dark2);
  margin-left: 2px;
}
.simple-dropdown-container .popover-content {
  height: auto;
  z-index: 100;
}
.simple-dropdown-container .popover-content.popover-hidden {
  display: none;
}
.simple-dropdown-container .popover-content .simple-card-container {
  padding: 0;
}
.simple-dropdown-container .popover-content .option {
  font-size: 0.9em;
  cursor: pointer;
  padding: 6px;
  color: var(--gray_dark2);
}
.simple-dropdown-container .popover-content .option span {
  min-width: 140px;
  white-space: pre;
}
.simple-dropdown-container .popover-content .option.active {
  font-weight: 600;
  background-color: var(--color_primary_500);
  color: var(--base_color2);
}
.simple-dropdown-container .popover-content .option:hover {
  background-color: var(--primary_light2);
  color: var(--base_color2);
}
.simple-dropdown-container .popover-content .option.active:hover {
  background-color: var(--color_primary_500);
  color: var(--base_color2);
}
.simple-dropdown-container .popover-content .option.disabled {
  pointer-events: none;
  color: var(--gray);
}
.simple-dropdown-container .tooltip-helper {
  margin-left: 2px;
}
.simple-dropdown-container .tooltip-helper svg {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/SimpleDropdown/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AACF;AACE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AACJ;AAEE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AAAJ;AAGE;EACE,eAAA;EACA,wBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAGI;EACE,yBAAA;EACA,YAAA;AADN;AAGM;EACE,wBAAA;AADR;AAKI;EACE,uBAAA;EACA,gBAAA;AAHN;AAOE;EACE,YAAA;EACA,YAAA;AALJ;AAOI;EACE,aAAA;AALN;AAQI;EACE,UAAA;AANN;AASI;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;AAPN;AASM;EACE,gBAAA;EACA,gBAAA;AAPR;AAUM;EACE,gBAAA;EACA,0CAAA;EACA,yBAAA;AARR;AAWM;EACE,uCAAA;EACA,yBAAA;AATR;AAaQ;EACE,0CAAA;EACA,yBAAA;AAXV;AAeM;EACE,oBAAA;EACA,kBAAA;AAbR;AAkBE;EACE,gBAAA;AAhBJ;AAkBI;EACE,cAAA;AAhBN","sourcesContent":[".simple-dropdown-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  z-index: 2;\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  .label {\n    color: var(--gray);\n    font-size: 14px;\n    margin-right: 4px;\n  }\n\n  .selected-value {\n    cursor: pointer;\n    color: var(--gray_dark2);\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n\n    &.disabled {\n      color: var(--gray_light1);\n      cursor: auto;\n\n      .drop-icon {\n        fill: var(--gray_light1);\n      }\n    }\n\n    .drop-icon {\n      fill: var(--gray_dark2);\n      margin-left: 2px;\n    }\n  }\n\n  .popover-content {\n    height: auto;\n    z-index: 100;\n\n    &.popover-hidden {\n      display: none;\n    }\n\n    .simple-card-container {\n      padding: 0;\n    }\n\n    .option {\n      font-size: 0.9em;\n      cursor: pointer;\n      padding: 6px;\n      color: var(--gray_dark2);\n\n      span {\n        min-width: 140px;\n        white-space: pre;\n      }\n\n      &.active {\n        font-weight: 600;\n        background-color: var(--color_primary_500);\n        color: var(--base_color2);\n      }\n\n      &:hover {\n        background-color: var(--primary_light2);\n        color: var(--base_color2);\n      }\n\n      &.active {\n        &:hover {\n          background-color: var(--color_primary_500);\n          color: var(--base_color2);\n        }\n      }\n\n      &.disabled {\n        pointer-events: none;\n        color: var(--gray);\n      }\n    }\n  }\n\n  .tooltip-helper {\n    margin-left: 2px;\n\n    svg {\n      display: block;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
